import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import PaperDataTableHead from '@linc-technologies/linced-common/components/paper-data-table-head';
import PaperDataTableBody from '@linc-technologies/linced-common/components/paper-data-table-body';
import PaperDataTableRow from '@linc-technologies/linced-common/components/paper-data-table-row';

export default class PaperDataTable extends Component {
  get headComponent() {
    // enable consumers to override the head component used.
    return this.args.headComponent ?? PaperDataTableHead;
  }

  get bodyComponent() {
    // enable consumers to override the body component used.
    return this.args.bodyComponent ?? PaperDataTableBody;
  }

  get bodyRowComponent() {
    // enable consumers to override the row component used.
    return this.args.bodyRowComponent ?? PaperDataTableRow;
  }

  // Local sort state, seeded from the args. Once the user sorts (and no
  // onChangeSort handler is supplied) the component owns these values.
  @tracked _sortProp;
  @tracked _sortDir;
  @tracked rowWidth = 0;

  get sortProp() {
    return this._sortProp === undefined
      ? (this.args.sortProp ?? '')
      : this._sortProp;
  }

  get sortDir() {
    return this._sortDir === undefined
      ? (this.args.sortDir ?? 'asc')
      : this._sortDir;
  }

  get selectable() {
    return this.args.selectable ?? false;
  }

  get sortDesc() {
    return `${this.sortProp}:${this.sortDir}`;
  }

  @action
  sortChanged(sortProp, sortDir) {
    if (this.args.onChangeSort) {
      this.args.onChangeSort({ sortProp, sortDir });
    } else {
      this._sortProp = sortProp;
      this._sortDir = sortDir;
    }
  }

  @action
  setRowWidth(width) {
    this.rowWidth = width;
  }
}
